import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

export const initialState = {
  model: {},
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
};

const entityJurisdictionInfo = createSlice({
  name: 'entityJurisdictionInfo',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
  },
});

export const {
  reset: entityJurisdictionInfoReset,
  request: entityJurisdictionInfoRequest,
  success: entityJurisdictionInfoSuccess,
  failure: entityJurisdictionInfoFailure,
} = entityJurisdictionInfo.actions;

export default entityJurisdictionInfo.reducer;
